import React from 'react';

//CORE COMPONENTS
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';
import styled from 'styled-components';

import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../components-core/packages/components-core/dist/container/index';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { Text, TextAppearance } from '../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';

//CUSTOM COMPONENTS
import LineLane from './components/LineLane';

const TopContainer = styled.div`
    width: 100vw;
`;

class ModelHighlights extends React.Component {

    renderHighlight() {
        const dataSet = sampleData(this.props);

        const renderedData = dataSet.map(data => 
            <Container wrap={ContainerWrap.always} padding={{ right: ContainerPadding.dynamic0100}} >
                <Text appearance={TextAppearance.copy0200}>{data.title}</Text>
                <Text appearance={TextAppearance.headline0250} bold>{data.data}</Text>
            </Container>    
        )

        return (
            <Container padding={highlightContainerPadding} gutter={ContainerGutter.dynamic0100}>
                {renderedData}
            </Container>
        )
    }

    render() {
        return (
            <IntegratorRoot>
                <ThemeProvider>
                    <TopContainer>
                        <Container 
                            horizontalAlign={ContainerHorizontalAlignment.flexStart}
                            verticalAlign={ContainerVerticalAlignment.flexStart}
                            wrap={ContainerWrap.always}
                            stretchContent
                            gutter={ContainerGutter.dynamic0200}
                        >
                            {this.renderHighlight()}
                            <LineLane {...this.props} />
                        </Container>
                    </TopContainer>
                </ThemeProvider>
            </IntegratorRoot>
        )
    }
}


const highlightContainerPadding = {
    left: { 
        [Breakpoints.default]: ContainerPadding.grid002, 
        [Breakpoints.b960]: ContainerPadding.grid003
    },
    right: { 
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid003,
    }
}

const sampleData = (props) => [
    {
        'title': props.custom,
        'data': props.custom4,
    },
    {
        'title': props.custom1,
        'data': props.custom5
    },
    {
        'title': props.custom2,
        'data': props.custom6
    },
    {
        'title': props.custom3,
        'data': props.custom7
    }
]

export default ModelHighlights;
